module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qresp10-82f02d94fefb51116e16dcd0d18c07ad.jpg";